import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';

function Main() {

return (
 <div className="container" id="home">
    <div className="about-section">
      <div className="content">
        <h1>TAI–CLAIM–ICR</h1>

        <p>
          The TAI–ICR–CLAIM initiative is a cluster of projects built on complementarity and synergy. It unites expertise in AI reasoning, computational law and machine ethics, and trustworthy AI to drive joint research that connects strong AI foundations with high-impact applications. Built on a foundation of successfully awarded projects, the initiative is guided by a clear idea: together, we can achieve more than we ever could individually.
        </p>
      </div>
    </div>
  </div>
);
}

export default Main;